export const XPATH_BUTTONS = 'XPATH_BUTTONS';
export const CARD_BUTTON = 'CARD_BUTTON';
